import { Injectable } from '@angular/core';
import { FuseNavigation } from '@fuse/types';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class AppService {

    constructor(private _translateService: TranslateService) { }

    translateLeftSideBar(navigation: FuseNavigation[]): FuseNavigation[] {
        navigation.forEach((value, key) => {
            this.leftSideItemTranslate(navigation[key], value);
        });
        return navigation;
    }

    private leftSideItemTranslate(obj, value): void {
        obj.title = this._translateService.instant(value.translate);
        if (obj?.children) {
            obj.children.forEach((childValue, childkey) => {
                this.leftSideItemTranslate(obj.children[childkey], childValue);
            });
        }
    }

}
